import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPortuguesePaginatorService } from '@portal/shared/services/mat-portuguese-paginator.service';
import { LOCALE_ID, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RouterModule, ExtraOptions, PreloadAllModules } from '@angular/router';
import { appRoutes } from 'app/app.routing';
import { EditorModule } from '@tinymce/tinymce-angular';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { appConfig } from 'app/core/config/app.config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { mockApiServices } from 'app/mock-api';
import { CoreModule } from 'app/core/core.module';
import { LayoutModule } from 'app/layout/layout.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedMatTableModule } from '@portal/shared/shared-mat-table.module';
import { ComponentsModule } from './app/modules/admin/shared/components/components.module';
import { QuillModule } from 'ngx-quill';
import { AppComponent } from './app/app.component';

// Dados de locale pt-PT para os pipes de moeda/data (estava no AppModule; a migração standalone não o traz)
registerLocaleData(localePt, 'pt-PT');

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    // 'disabled' instead of 'enabled': the router's own automatic scroll handling on
    // back/popstate navigation was competing with (and overriding) manual scroll restoration
    // implemented by individual pages (e.g. donations list). Forward-navigation scroll-to-top
    // is replicated manually in AppComponent so other pages keep that behavior.
    scrollPositionRestoration: 'disabled'
};
const QUILL_SIZES = ['10px','12px','14px','16px','18px','20px','24px','28px','32px','40px','48px','56px','64px','80px','96px'];



bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        importProvidersFrom(NgxMatTimepickerModule.setLocale('pt-PT')),importProvidersFrom(BrowserModule, RouterModule.forRoot(appRoutes, routerConfig), EditorModule, 
        // Fuse, FuseConfig & FuseMockAPI
        FuseModule, FuseConfigModule.forRoot(appConfig), FuseMockApiModule.forRoot(mockApiServices), 
        // Core module of your application
        CoreModule, 
        // Layout module of your application
        LayoutModule, ReactiveFormsModule, SharedMatTableModule, ComponentsModule, QuillModule.forRoot({
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'size': QUILL_SIZES }],
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    [{ 'align': [] }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'indent': '-1' }, { 'indent': '+1' }],
                    [{ 'script': 'sub' }, { 'script': 'super' }],
                    ['blockquote', 'code-block'],
                    ['link'],
                    ['clean'],
                ]
            },
            customOptions: [
                {
                    import: 'attributors/style/size',
                    whitelist: QUILL_SIZES
                },
                {
                    import: 'attributors/style/align',
                    whitelist: [false, 'center', 'right', 'justify']
                }
            ],
            theme: 'snow',
            placeholder: 'Digite o texto aqui...',
            suppressGlobalRegisterWarning: true,
        })),
        { provide: MatPaginatorIntl, useClass: MatPortuguesePaginatorService },
        { provide: LOCALE_ID, useValue: 'pt-PT' },
        provideAnimations()
    ]
})
    .catch(err => console.error(err));
